export enum BetSlipModeEnum {
    Single = "SINGLE",
    Combi = "COMBI",
    System = "SYSTEM"
}